const ServiceReg = () => {
  return (
    <section
      className="col-12 ps-3 pe-3"
      style={{ maxWidth: "1000px", margin: "auto" }}
    >
      <p className="text-uppercase text-success fw-bold fs-3 pt-3 text-center">
        Điều khoản dịch vụ
      </p>
      <p className="fw-bold">1. Thông tin về điều kiện giao dịch chung</p>
      <p>
        <i>
          a) Các điều kiện hoặc hạn chế trong việc cung cấp hàng hóa hoặc dịch
          vụ:
        </i>{" "}
        Tã bỉm Mễ Mễ liên kết với các đơn vị giao hàng bên thứ ba để thực hiện
        dịch vụ giao hàng toàn quốc, các khu vực địa lý bị hạn chế giao hàng tùy
        thuộc vào quy định của các đơn vị giao hàng.
      </p>

      <p>
        <i>b) Chính sách kiểm hàng - hoàn trả:</i>
        <br></br>- Chính sách kiểm hàng: Khi nhận được đơn hàng từ nhân viên
        giao vận, khách hàng được quyền kiểm tra bao bì bên ngoài sản phẩm để
        đảm bảo đúng dòng bỉm, đúng size và số lượng đã đặt. Xin lưu ý, không
        được bóc hoặc mở bịch bỉm để kiểm tra bên trong nhằm đảm bảo vệ sinh và
        chất lượng sản phẩm.<br></br>- Chính sách hoàn trả: Tã bỉm Mễ Mễ chấp
        nhận đổi hàng đối với các sản phẩm còn nguyên tem, chưa bóc, chưa qua sử
        dụng do khách hàng đặt nhầm size, nhầm dòng. Để đổi sản phẩm, khách hàng
        vui lòng liên hệ theo hotline: 0916 23 86 23 hoặc nhắn tin về Website,
        Fanpage hoặc Zalo của chúng tôi và làm theo hướng dẫn của nhân viên tư
        vấn. Khách hàng vui lòng thanh toán chi phí vận chuyển cho đơn hàng đổi
        trả.
      </p>
      <p>
        <i>c) Chính sách bảo hành sản phẩm</i> <br></br>
        Mễ Mễ có hỗ trợ bảo hành áp dụng đặc biệt với những khách hàng mua lần
        đầu theo bịch chi tiết như sau:
      </p>
      <p>- Trường hợp sử dụng sản phẩm bị kích ứng</p>
      <ul>
        <li>
          Quy định áp dụng: Áp dụng trong 10 miếng bỉm sử dụng của bịch đầu
          tiên, khách hàng cần cung cấp thông tin và hình ảnh về trình trạng sử
          dụng sản phẩm.
        </li>
        <li>
          Quy trình khi đổi trả: Khách hàng gửi ảnh tình trạng kích ứng về zalo
          SĐT 0916 23 86 23, nhãn hàng sẽ liên hệ hỗ trợ đổi trả theo nhu cầu
          của mẹ, đổi trả tiến hành sau khi có sự đồng ý từ khách hàng, khách
          hàng chịu phí ship gửi hàng về shop. Shop nhận hàng kiểm tra và tiến
          hành hoàn tiền theo giá trị đơn hàng.
        </li>
      </ul>
      <p>
        - Trường hợp lỗi do nhà sản xuất:<br></br>Sản phẩm tã bỉm Mễ Mễ được áp
        dụng chính sách 1 đổi 1 đối với các lỗi phát sinh do nhà sản xuất (ví
        dụ: lỗi dán, lỗi chất liệu, ...). Thời gian áp dụng đổi sản phẩm lỗi là
        trong vòng 7 ngày kể từ khi nhận hàng. Vui lòng giữ nguyên bao bì và
        liên hệ với chúng tôi để được hỗ trợ nhanh nhất.
      </p>

      <p>
        <i>
          d) Các tiêu chuẩn dịch vụ, quy trình cung cấp dịch vụ, biểu phí và các
          điều khoản khác liên quan đến việc cung cấp dịch vụ
        </i>
      </p>

      <ul>
        <li>
          <strong>Tiêu chuẩn dịch vụ: </strong>Sản phẩm tã bỉm Mễ Mễ Việt Nam
          được cam kết là hàng chính hãng, mới 100%, đảm bảo chất lượng theo
          tiêu chuẩn nhà sản xuất; Giao hàng đúng sản phẩm, đủ số lượng, đúng
          size và dòng bỉm như đã đặt; Hỗ trợ khách hàng nhanh chóng qua
          hotline, fanpage hoặc email trong giờ hành chính.
        </li>

        <li>
          <strong>Quy trình cung cấp dịch vụ: </strong>Tiếp nhận đơn hàng từ
          khách qua website, fanpage hoặc hotline; Xác nhận thông tin và tiến
          hành đóng gói, giao hàng; Cập nhật tình trạng đơn hàng cho khách nếu
          có yêu cầu; Xử lý các yêu cầu đổi trả, khiếu nại (nếu có) theo chính
          sách công bố.
        </li>

        <li>
          <strong>Biểu phí: </strong>Giá sản phẩm được niêm yết rõ ràng theo đơn
          vị VNĐ trên website và đã bao gồm VAT; Phí vận chuyển sẽ được tính
          theo khu vực và phương thức giao hàng, hiển thị trước khi đặt hàng
          hoàn tất; Các chương trình miễn phí vận chuyển (nếu có) sẽ được công
          bố cụ thể tại từng thời điểm.
        </li>

        <li>
          <strong>Điều khoản và điều kiện khác: </strong>Sản phẩm đã sử dụng, đã
          bóc bao bì sẽ không được đổi trả, trừ trường hợp lỗi do nhà sản xuất;
          Một số chương trình khuyến mãi có thể giới hạn về thời gian áp dụng,
          số lượng mua hoặc khu vực giao hàng; Trong trường hợp xảy ra sự cố
          ngoài ý muốn (thiên tai, dịch bệnh, gián đoạn vận chuyển...), thời
          gian giao hàng có thể chậm hơn so với dự kiến, chúng tôi sẽ chủ động
          liên hệ để thông báo và hỗ trợ khách hàng.
        </li>
      </ul>

      <p>
        <i>
          e) Nghĩa vụ của người bán và nghĩa vụ của khách hàng trong mỗi giao
          dịch.
        </i>
      </p>
      <p>- Trách nhiệm của nhãn hàng tã bỉm Mễ Mễ Việt Nam:</p>
      <ul>
        <li>
          Cung cấp thông tin sản phẩm rõ ràng, minh bạch, đúng với mô tả trên
          website.
        </li>
        <li>Xác nhận và xử lý đơn hàng nhanh chóng.</li>
        <li>Giao hàng đúng sản phẩm, đúng size, số lượng như đã đặt.</li>
        <li>Hỗ trợ đổi trả, bảo hành theo chính sách công bố.</li>
        <li>Bảo mật thông tin cá nhân của khách hàng.</li>
        <li>Hỗ trợ giải quyết khiếu nại liên quan đến đơn hàng.</li>
      </ul>

      <p>- Trách nhiệm của khách hàng:</p>
      <ul>
        <li>Cung cấp thông tin cá nhân và địa chỉ nhận hàng chính xác.</li>
        <li>
          Kiểm tra bao bì sản phẩm khi nhận hàng và phản hồi nếu có vấn đề.
        </li>
        <li>Thanh toán đầy đủ (nếu chọn hình thức COD).</li>
        <li>Giữ gìn sản phẩm nguyên vẹn nếu muốn đổi/trả hoặc khiếu nại.</li>
        <li>Không lợi dụng chính sách đổi trả/bảo hành để trục lợi.</li>
      </ul>

      <p className="fw-bold">2. Thông tin về vận chuyển và giao nhận</p>

      <p>
        <i>a) Các phương thức giao hàng hoặc cung ứng dịch vụ</i>
      </p>
      <p>
        Chúng tôi hỗ trợ giao hàng toàn quốc thông qua nhiều đơn vị vận chuyển
        uy tín, bao gồm: Viettel Post, VNPost, J&T Express, Giao Hàng Nhanh
        (GHN), Ninja Van, Best Express, Shopee Express, Grab, Ahamove, Be...
      </p>

      <p>
        <i>
          b) Thời hạn ước tính cho việc giao hàng hoặc cung ứng dịch vụ, có tính
          đến yếu tố khoảng cách địa lý và phương thức giao hàng
        </i>
      </p>
      <p>
        Tùy khu vực và nhu cầu, khách hàng có thể lựa chọn: <br></br>– Giao hàng
        tiêu chuẩn (ship thường): thời gian từ 2–5 ngày làm việc <br></br>– Giao
        hàng hỏa tốc: giao trong ngày hoặc trong vòng 24h (áp dụng tại Hà Nội)
      </p>

      <p>
        <i>
          c) Các giới hạn về mặt địa lý cho việc giao hàng hoặc cung ứng dịch vụ
        </i>
      </p>
      <p>
        Hiện tại, tã bỉm Mễ Mễ chủ yếu được phân phối và giao hàng trong phạm vi
        lãnh thổ Việt Nam. Việc giao hàng được triển khai trên toàn quốc, bao
        gồm các tỉnh thành từ Bắc đến Nam thông qua các đối tác vận chuyển như
        Viettel Post, VNPost, J&T Express, Giao hàng nhanh… <br></br>
        Tuy nhiên, trong một số trường hợp đặc biệt, việc giao hàng có thể bị
        giới hạn hoặc chậm trễ tại các khu vực sau:<br></br>- Các vùng sâu, vùng
        xa, hải đảo hoặc khu vực có điều kiện giao thông khó khăn.<br></br>- Khu
        vực bị ảnh hưởng bởi thiên tai, dịch bệnh hoặc quy định hạn chế vận
        chuyển từ cơ quan chức năng.<br></br>- Một số địa chỉ cụ thể ngoài vùng
        phục vụ của đơn vị vận chuyển đối tác.<br></br> Khách hàng nên liên hệ
        trực tiếp với bộ phận chăm sóc khách hàng của Tã bỉm Mễ Mễ để được kiểm
        tra và xác nhận phạm vi giao hàng cụ thể.
      </p>

      <p>
        <i>
          d) Phân định trách nhiệm của thương nhân, tổ chức cung ứng dịch vụ
          logistics về cung cấp chứng từ hàng hóa trong quá trình giao nhận.
        </i>
      </p>
      <p>- Trách nhiệm của thương nhân (Tã bỉm Mễ Mễ Việt Nam):</p>
      <ul>
        <li>
          Chịu trách nhiệm chính trong việc đóng gói, kiểm tra chất lượng, và
          bàn giao hàng hóa cho đơn vị vận chuyển đúng thời hạn.
        </li>
        <li>
          Phối hợp với đơn vị logistics để theo dõi và xử lý kịp thời nếu phát
          sinh vấn đề trong quá trình vận chuyển.
        </li>
        <li>
          Thông báo đầy đủ, minh bạch cho khách hàng về tình trạng đơn hàng,
          thời gian dự kiến giao hàng, các trường hợp có thể chậm trễ và cách xử
          lý.
        </li>
        <li>Cung cấp hóa đơn, chứng từ liên quan nếu khách hàng yêu cầu.</li>
      </ul>

      <p>
        - Trách nhiệm của đơn vị cung ứng dịch vụ logistics (đơn vị vận chuyển):
      </p>
      <ul>
        <li>
          Nhận hàng và thực hiện vận chuyển theo đúng thông tin, thời gian và
          địa chỉ do thương nhân cung cấp.
        </li>
        <li>
          Bảo quản hàng hóa trong quá trình vận chuyển, tránh hư hỏng, thất lạc.
        </li>
        <li>
          Giao hàng cho đúng người nhận, có thể yêu cầu xác minh qua mã vận đơn,
          số điện thoại hoặc chứng minh thư.
        </li>
        <li>
          Cung cấp thông tin định vị, mã vận đơn để khách hàng có thể theo dõi
          đơn hàng.
        </li>
      </ul>

      <p>
        Lưu ý quan trọng:<br></br>- Nếu có chậm trễ trong quá trình giao hàng,
        Mễ Mễ và/hoặc đơn vị vận chuyển sẽ chủ động thông báo cho khách hàng và
        tạo điều kiện để khách có thể hủy đơn nếu muốn.
      </p>
    </section>
  );
};

export default ServiceReg;
